import { validateFormField } from '../helper/helpers';

export default class Login {
  constructor() {
    const loginForm = document.getElementById('loginForm');

    if (!loginForm) {
      return;
    }

    this.loginForm = loginForm;
    this.btnSubmit = loginForm.querySelector('button[type="submit"]');
    this.fieldsRequired = loginForm.querySelectorAll('[required]');

    this.fieldsRequired.forEach((el) =>
      el.addEventListener('input', this.validateFields),
    );
    this.validateFields();

    window.addEventListener('keyup', (e) => this.handleKeyup(e));
  }

  /**
   * Validates the form fields and toggles the disabled-state of the submit-button.
   */
  validateFields = () => {
    if (Array.from(this.fieldsRequired).some((el) => !validateFormField(el))) {
      this.btnSubmit.setAttribute('disabled', true);
    } else {
      this.btnSubmit.removeAttribute('disabled');
    }
  };

  /**
   * Handles the keyup event, submits the form on enter.
   * @param {Event} e
   */
  handleKeyup(e) {
    if (e.key === 'Enter' && !this.btnSubmit.hasAttribute('disabled')) {
      this.loginForm.submit();
    }
  }
}
